if (!customElements.get('faq-section')) {
  class FaqSection extends HTMLElement {
    constructor() {
      super();
      this.checkDeepLinking();
      this.faqIds = this.querySelectorAll('[data-set-faq-id]');
      this.faqIds.forEach((faqId) => {
        // Catch click on collapsible trigger
        faqId.querySelector('[data-collapsible-trigger]').addEventListener('click', (event) => {
          const target = event.currentTarget.closest('[data-set-faq-id]');
          const faqId = target.id;
          if (!faqId) return;
          // set hash without scrolling
          target.id = `${faqId}-tmp`;
          window.location.hash = faqId;
          elem.id = faqId;
          event.preventDefault();
        });
      });
    }
    checkDeepLinking() {
      const hash = window.location.hash;
      if (!hash) return;
      const target = this.querySelector(`${hash}`);
      if (!target) return;
      target.classList.add('collapsible-is-open');
    }
  }
  customElements.define('faq-section', FaqSection);
}
